import { CatchmentItemResult } from '../../types/Catchment';

export function buildCatchmentFilter(filter: string) {
  const loweredFilter = filter.toLocaleLowerCase();
  return (item: CatchmentItemResult) =>
    item?.origin?.toLocaleLowerCase().startsWith(loweredFilter) ||
    item?.origin_type?.toLocaleLowerCase().includes(loweredFilter) ||
    item.path.findIndex((crumb) => crumb.startsWith(filter)) > -1;
}
